import React, { Fragment } from 'react';
import styles from './styles.scss';
import Tooltip from '../Tooltip';
import { Icons } from '@densityco/ui';

export const FORCE_BREAK = 'FORCE_BREAK' as const;

export type DataGridProps = {
  items: Array<
    | {
        id: any;
        label: React.ReactNode;
        value: React.ReactNode;
        tooltip?: React.ReactNode;
      }
    | typeof FORCE_BREAK
  >;
};

const DataGrid: React.FunctionComponent<DataGridProps> = ({ items }) => {
  const groups = items.reduce(
    (groups, item) => {
      if (item === FORCE_BREAK) {
        groups.push([]);
      } else {
        groups[groups.length - 1].push(item);
      }
      return groups;
    },
    [[]],
  );

  return (
    <div className={styles.wrapper}>
      {groups.map((group, index) => (
        <div className={styles.group} key={index}>
          {group.map(item => (
            <div className={styles.item} key={item.id}>
              <span className={styles.itemHeader}>
                {item.tooltip ? (
                  <Tooltip
                    contents={item.tooltip}
                    target={
                      <Fragment>
                        {item.label}
                        <span className={styles.infoIcon}>
                          <Icons.Info width={10} height={10} color="currentColor" />
                        </span>
                      </Fragment>
                    }
                  />
                ) : (
                  item.label
                )}
              </span>
              <span className={styles.itemValue}>{item.value}</span>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};
export default DataGrid;
